import { render, staticRenderFns } from "./CadManual.vue?vue&type=template&id=05c65a8b&scoped=true&"
import script from "./CadManual.vue?vue&type=script&lang=js&"
export * from "./CadManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c65a8b",
  null
  
)

export default component.exports